import { PYTHON_API_BASE_URL } from "../../../services/api/apiConstants";
import { encryptPassword } from "../../../encryption";
import { emailQuery } from "../domain/emailQuery";

function buildHeaders({ accessToken, userId }) {
  return {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
    "X-User-ID": userId || "",
  };
}

export async function fetchEmployeesByBranchAdmin({ accessToken, email, userId }) {
  const endpoint = `${PYTHON_API_BASE_URL}/employees/by-branch-admin-email/?${emailQuery(email)}`;

  const response = await fetch(endpoint, {
    method: "GET",
    headers: buildHeaders({ accessToken, userId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch employees: ${response.status}`);
  }

  const data = await response.json();
  return data.employees || [];
}

export async function updateEmployee({ accessToken, userId, employeeId, formData }) {
  const response = await fetch(`${PYTHON_API_BASE_URL}/users/update/`, {
    method: "PUT",
    headers: buildHeaders({ accessToken, userId }),
    body: JSON.stringify({
      user_id: employeeId,
      first_name: formData.firstName,
      last_name: formData.lastName,
      phone: formData.phone,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    const errorMsg = data.error?.message || data.error || "Failed to update employee. Please try again.";
    throw new Error(errorMsg);
  }

  return data;
}

export async function createEmployee({ accessToken, userId, branchId, formData }) {
  const endpoint = formData.admin === "yes"
    ? `${PYTHON_API_BASE_URL}/employees/create-branch-admin/`
    : `${PYTHON_API_BASE_URL}/employees/create/`;

  const response = await fetch(endpoint, {
    method: "POST",
    headers: buildHeaders({ accessToken, userId }),
    body: JSON.stringify({
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      password: encryptPassword(formData.password),
      phone: formData.phone,
      is_admin: formData.admin,
      branch_id: branchId,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    let errorMsg = "Failed to create employee. Please try again.";
    if (data) {
      const messages = Object.values(data).flat().join(", ");
      if (messages) errorMsg = messages;
    }
    throw new Error(errorMsg);
  }

  return data;
}
